import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';
import { initializeTokenTracking, getUserToken } from './utils/tokenTracking';

// Suppress browser extension errors in console (harmless extension interference)
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    (args[0].includes('message channel closed') ||
     args[0].includes('listener indicated an asynchronous response'))
  ) {
    return; // Suppress extension-related errors
  }
  originalError.apply(console, args);
};

// Initialize token tracking on app load
initializeTokenTracking();

// Expose token checking function to window for debugging (development only)
if (process.env.NODE_ENV === 'development') {
  window.checkUserToken = () => {
    const currentToken = getUserToken();
    console.log('🔍 Current user token:', currentToken);
    console.log('📦 Stored in localStorage:', localStorage.getItem('user_tracking_token'));
    return currentToken;
  };
  console.log('💡 Debug: Use window.checkUserToken() to check the current token');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
